<div class="numbers-page">
  <div class="title">
    <h2 class="vox-heading-2" translate>numbers.title</h2>
  </div>
  <hr />
  <div class="numbers-page__container">
    <div class="numbers-page__filters">
      <gdp-company-dids-filters (onFilter)="onFilter($event)" [quickFilters]="filtersArray">
      </gdp-company-dids-filters>
    </div>
    <div class="numbers-page__table">
      <gdp-numbers-table [dids]="dids" [loading]="loading" [pageSize]="pageSize"></gdp-numbers-table>
    </div>
    <div class="numbers-page__pagination">
      <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)"
        (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages" [pagination]="pagination"
        [selectedPageSize]="pageSize"></gdp-table-pagination>
    </div>
  </div>
</div>